import { Label } from "@patient-watch/ui/label";
import Input from "./Input";

const Address = () => {
    return (
        <fieldset className="govuk-fieldset">
            <legend>
                <h3 className="">What is your address?</h3>
            </legend>
            <div className="govuk-form-group">
                <Label className="govuk-Label" htmlFor="address-line-1">
                    Address line 1
                </Label>
                <Input id="address-line-1" name="addressLine1" type="text" autocomplete="address-line1" />
            </div>
            <div className="govuk-form-group">
                <Label className="govuk-Label" htmlFor="address-line-2">
                    Address line 2 (optional)
                </Label>
                <Input id="address-line-2" name="addressLine2" type="text" autocomplete="address-line2" />
            </div>
            <div className="govuk-form-group">
                <Label className="govuk-Label" htmlFor="address-town">
                    Town or city
                </Label>
                <Input id="address-town" name="addressTown" type="text" autocomplete="address-level2" />
            </div>
            <div className="govuk-form-group">
                <Label className="govuk-Label" htmlFor="address-county">
                    County (optional)
                </Label>
                <Input id="address-county" name="addressCounty" type="text" />
            </div>
            <div className="govuk-form-group">
                <Label className="govuk-Label" htmlFor="address-postcode">
                    Postcode
                </Label>
                <Input id="address-postcode" name="addressPostcode" type="text" autocomplete="postal-code" />
            </div>
        </fieldset>
    );
};

export default Address;
